export const setFrames = (bookGroup, sheet) => {
  console.log("setFrames :>> start");
  let returnFrames = [];

  bookGroup.books.forEach(function (bookEach) {
    bookEach.sheets.forEach(function (sheetEach) {
      if (sheet.master_sheet_id == sheetEach.master_sheet_id) {
        sheetEach.frames.forEach(function (frameEach) {
          returnFrames.push(frameEach);
        });
      }
    });
  });

  console.log("returnFrames :>> ", returnFrames);
  console.log("setFrames :>> end");
  return returnFrames;
};
